import {
  clearForm,
  setData,
  setError,
  setReason,
  setStatus,
} from "@/redux/slices/commonSlices/requestSlice";

import {useEffect} from "react";

import {ControlButton} from "@ui/buttons/ControlButton";
import {RootInput} from "@ui/inputs/RootInput";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const ChangeRequestPopup = () => {
  const {t} = useTranslation();
  const {data, reason, error, status} = useSelector(
    (state) => state.common.request,
  );
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(setError(""));

    if (!data || !reason) {
      dispatch(setError(t("server_error.fields")));
      return;
    }

    dispatch(setStatus("loading"));

    const timer = setTimeout(() => {
      dispatch(setStatus(""));
      dispatch(clearForm());
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        dispatch(setError(""));
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [error, dispatch]);

  return (
    <div className={styles.change}>
      <H3>{t("popup.change_req.title")}</H3>

      <form
        onSubmit={handleSubmit}
        className={styles.changeForm}
      >
        <div className={styles.input}>
          <RootInput
            width={500}
            label={t("input.which_change")}
            type={"text"}
            value={data}
            required
            onChange={(e) => dispatch(setData(e.target.value))}
            disabled={status === "loading" && true}
          />
        </div>

        <div className={styles.input}>
          <RootInput
            width={500}
            label={t("input.reason_change")}
            type={"text"}
            value={reason}
            required
            onChange={(e) => dispatch(setReason(e.target.value))}
            disabled={status === "loading" && true}
          />
        </div>

        <ControlButton
          color={
            !data || !reason || status === "loading"
              ? "var(--grey)"
              : "var(--blue)"
          }
          txt={t("button.send_req")}
          type={"submit"}
          disabled={!data || !reason || status === "loading"}
        />
      </form>
    </div>
  );
};
